// Mismo patrón que StockIA: formatter a nivel de módulo (no por llamada),
// null/undefined -> em dash en vez de lanzar.
const copFormatter = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

const percentFormatter = new Intl.NumberFormat('es-CO', {
  style: 'percent',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

const dateFormatter = new Intl.DateTimeFormat('es-CO', { day: '2-digit', month: 'short', year: 'numeric' });

export function formatCOP(value: number | null | undefined): string {
  if (value == null) return '—';
  return copFormatter.format(value);
}

/** value es una fracción (0.28 -> "28,00 %"), no un porcentaje ya multiplicado. */
export function formatRate(value: number | null | undefined): string {
  if (value == null) return '—';
  return percentFormatter.format(value);
}

export function formatMonths(months: number | null | undefined): string {
  if (months == null) return '—';
  if (months === 1) return '1 mes';
  if (months < 12) return `${months} meses`;
  const years = Math.floor(months / 12);
  const rest = months % 12;
  const yearsPart = `${years} ${years === 1 ? 'año' : 'años'}`;
  return rest === 0 ? yearsPart : `${yearsPart} y ${rest} ${rest === 1 ? 'mes' : 'meses'}`;
}

export function formatDate(value: string | null | undefined): string {
  if (!value) return '—';
  return dateFormatter.format(new Date(`${value}T00:00:00`));
}

const monthLabelFormatter = new Intl.DateTimeFormat('es-CO', { month: 'long', year: 'numeric' });

/** 'YYYY-MM' -> "Agosto 2026". */
export function formatMonthLabel(yyyyMm: string): string {
  const label = monthLabelFormatter.format(new Date(`${yyyyMm}-01T00:00:00`));
  return label.charAt(0).toUpperCase() + label.slice(1);
}
